<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_end')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.resources.end.mastered') }}
      </p>
      <p class="pb-2">
        <strong>{{ t('tutorial.resources.end.keyPrinciples') }}</strong><br>
        • {{ t('tutorial.resources.end.planetsGenerateOre') }}<br>
        • {{ t('tutorial.resources.end.tradeSurplus') }}<br>
        • {{ t('tutorial.resources.end.planRefineries') }}<br>
        • {{ t('tutorial.resources.end.monitorFlow') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.resources.end.strongEconomy') }}
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.resources.end.thankYou') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>